import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserCashDetail = React.lazy(() =>
    import('../UserCashDetail')
);
const userCashDetailRoutesRegistry = [
    {
        path: PAGE_URL.USER_CASH_DETAIL_PAGE,
        element: <UserCashDetail />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userCashDetailRoutesRegistry;
